module.exports = __webpack_public_path__ + "static/media/md-camera.464fa575.svg";